import { Api_downFile } from "../../api/downFile";
import store from "../../../../store/index";
import iView from "iview"

export default (ywlx, qflx = null) => {
    let dwzh = JSON.parse(sessionStorage.getItem('cominfo')).dwzh;
    store.commit('setDownLoading', true);
    console.log(iView);
    Api_downFile(dwzh, ywlx, qflx).then(res => {
        store.commit('setDownLoading', false);
        if (res.code === '0000000') {
            if (res.body) {
                let data = JSON.parse(res.body);
                console.log(data);
                if (data.status === '0') {
                    //判断文件类型
                    let type = data.result.upperCase;
                    let text;
                    switch (type) {
                        case 'xls':
                            text = 'application/vnd.ms-excel';
                            break;
                        case 'pdf':
                            text = 'application/pdf';
                            break;
                    }
                    //模拟a标签并拼接
                    let a = document.createElement('a');
                    a.setAttribute('href', 'data:' + text + ';base64,' + data.result.file);
                    a.setAttribute('download', data.result.fileName + '.xls');
                    // a.setAttribute('target', '_black');
                    document.querySelector('body').appendChild(a);
                    //模拟点击下载
                    a.click();
                    document.querySelector('body').removeChild(a);
                } else {
                    iView.Notice.error({
                        title: data.msg[0].cwxx
                    })
                }
            }
        }
    }).catch(err => {
        console.error(err);
        iView.Notice.error({
            title: '下载失败'
        });
        store.commit('setDownLoading', false);
    });
};



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/downFile.js